import { colors } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import shadows from "./shadows";
import typography from "./typography";
import { esES } from "@material-ui/core/locale";

const theme = createTheme(
  {
    palette: {
      background: {
        dark: "#FFFFFF",
        default: "#2d3239", //colors.common.white,
        paper: "#2d3239", //colors.common.white,
        paperM: "#FAF3F3",
        paperPrimary: "#ffffff",
        paperSecondary: "#79B4B7",
      },
      primary: {
        main: "#2d3239", // colors.indigo[500]
      },
      success: {
        main: "#2f994c", // colors.indigo[500]
      },
      secondary: {
        main: "#FFFFFF", //colors.indigo[500]
      },
      secondaryG: {
        main: "#C9D8B6", //colors.indigo[500]
      },
      info: {
        main: "#125D98", // colors.indigo[500]
      },
      add: {
        main: "#79B4B7", // colors.indigo[500]
      },
      warning: {
        main: "#bf2015", // colors.indigo[500]
      },
      input: {
        main: "#ececec",
      },
      delete: {
        main: "#bf2015",
      },
      alert: {
        main: "#FFC300",
      },
      finish: {
        main: "#68C25B",
      },
      excel: {
        main: colors.green[500],
      },
      text: {
        primary: "#CCCCCC", //colors.blueGrey[900],
        secondary: "#56776C", //colors.blueGrey[600]
        success: "#56776C",
      },
      ".btnExcel": {
        backgroundColor: "#1D6F42 !important",
        "&:hover": {
          backgroundColor: colors.green[500] + " !important",
        },
      },
      excel: {
        main: colors.teal[500],
      },
      bono: {
        silver: "#C0C0C0",
        gold: "#FFC107",
      },
      button: {
        primary: "#2d3239",
      },
    },
    shadows,
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            color: "#FFFFFF",
          },
          input: {
            background: "#fff",
            padding: "12px 14px",
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            color: "#FFFFFF",
            "&.Mui-focused": {
              color: "#79B4B7",
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            color: "#ffcc00",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderColor: "#515E63",
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFFFFF",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#79B4B7",
            },
          },
          notchedOutline: {
            borderColor: "#515E63",
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          root: {
            backgroundColor: "#2d3239",
            color: "#FFFFFF",
            padding: "16px",
          },
          toolbar: {
            justifyContent: "center",
          },
          select: {
            color: "#FFFFFF",
          },
          selectIcon: {
            color: "#FFFFFF",
          },
          input: {
            color: "#FFFFFF",
          },
          actions: {
            marginLeft: "8px",
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            backgroundColor: "#ececec",
            "& .MuiAutocomplete-inputRoot": {
              color: "#515E63",
            },
          },
          paper: {
            backgroundColor: "#ffffff",
            color: "#515E63",
          },
          option: {
            '&[aria-selected="true"]': {
              backgroundColor: "#79B4B7",
              color: "#ffffff",
            },
          },
        },
      },
    },
    // typography: {
    //     fontFamily: ['Nunito','sans-serif'].join(','),
    //     ...typography
    // },
    // components: {
    // 	typography: {
    // 		styleOverrides: {
    // 			root: {
    // 				color: '#A54800',
    // 				variants: [
    // 					{
    // 						props: { variant: 'body1' },
    // 						style: {
    // 							borderWidth: '3px',
    // 						},
    // 					},
    // 				],
    // 			},
    // 		},
    // 	},
    // }
  },
  esES
);

export default theme;
